<template>
  <div>
    <v-card v-if="complete">
      <v-card-title>
        Purchase complete
      </v-card-title>
      <v-card-text>
        You purchased {{ form.credits | pluralize('email verification credit') }}.
      </v-card-text>
      <v-card-actions>

      </v-card-actions>
    </v-card>
    <v-form v-else
            @submit.prevent="submit"
            :disabled="form.busy">
      <v-card>
        <v-card-title>
          Buy Credits
        </v-card-title>
        <v-card-text>
          <p>
            One credit is equal to one email validation. Credits expire after 365 days.
          </p>
          <v-select v-model.number="form.credits"
                    label="How many credits do you want to buy?"
                    outlined
                    :items="creditOptions"
                    item-value="id"
                    item-text="text"
                    required
                    @change="initializeStripe"
                    :error-messages="form.errors.get('credits')">
            <template v-slot:item="{item}">
              <div>
                <div>
                  {{ item.text }}
                </div>
                <div class="text-caption">
                  {{ item.rate_text }}
                </div>
              </div>
            </template>
          </v-select>

          <div ref="paymentElement">
            <!-- A Stripe element will be inserted here. -->
          </div>
        </v-card-text>
        <ErrorAlert v-if="paymentError"
                    :error="paymentError">
        </ErrorAlert>
        <v-card-actions v-if="form.credits">
          <v-btn color="primary"
                 type="submit"
                 :disabled="form.busy || isFormValid === false">
            Buy {{ form.credits | number }} {{ form.credits | pluralize('credit', false ) }} for {{ amount | money('$', 0) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import emailVerificationService from '../../../services/emailVerificationService';
import {find, isInteger} from 'lodash';
import ErrorAlert from '../../../components/ErrorAlert.vue';

export default {
  components: {ErrorAlert},
  data() {
    return {
      elements: null,
      form: new Form({
        credits: null,
        payment_intent: null,
      }),
      creditOptions: [],
      paymentElement: null,
      paymentFormValid: false,
      paymentError: null,
      stripe: null,
      complete: false,
    }
  },
  computed: {
    ...mapGetters([
      'config',
      'team',
      'user',
    ]),
    creditObject() {
      return find(this.creditOptions, c => c.id === this.form.credits);
    },
    amount() {
      if (this.creditObject) {
        return this.creditObject.id * this.creditObject.rate;
      }
      return null;
    },
    paymentElementComplete() {
      return this.paymentFormValid;
    },
    isFormValid() {
      return isInteger(this.form.credits)
        && this.form.credits > 0
        && this.paymentElementComplete;
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
    //this.initializeStripe();
  },
  methods: {
    async initializeStripe() {
      // @see https://docs.stripe.com/payments/quickstart
      const stripe = this.stripe = Stripe(this.config.stripeKey);

      const response = await this.form.post(`/api/email-verification-credits/create-payment-intent`);
      const clientSecret = response.data.client_secret;

      const elements = this.elements = stripe.elements({clientSecret});

      // @see https://docs.stripe.com/payments/payment-element
      const paymentElementOptions = {
        layout: 'accordion',
      }
      this.paymentElement = elements.create('payment', paymentElementOptions);
      this.paymentElement.mount(this.$refs.paymentElement);

      this.paymentElement.on('change', (event) => {
        console.log(event);
        if (event.error) {
          this.paymentFormValid = false;
        } else if (event.complete) {
          this.paymentFormValid = true;
        }
      })
    },
    async fetchData() {
      this.creditOptions = await emailVerificationService.getCreditOptions();
    },
    async submit() {
      if (this.form.busy) {
        return;
      }
      if (this.isFormValid === false) {
        this.paymentError = {message: 'Please enter your payment details.'}
      }
      this.paymentError = null;
      this.form.payment_intent = null;

      this.form.startProcessing();

      try { // @see https://docs.stripe.com/js/payment_intents/confirm_payment
        const {paymentIntent} = await this.stripe.confirmPayment({
          elements: this.elements,
          confirmParams: {
            return_url: `https://${location.hostname}/v2/admin/verify/email-lists?success=true`
          },
          redirect: 'if_required',
        })

        this.form.payment_intent = paymentIntent;
        await this.form.post(`/api/email-verification-credits/purchase`)
        this.$emit('updated');
        this.$toast.success('Purchase successful.');
      } catch (error) {
        this.paymentError = error;
      }


      /*const {token, error} = await this.stripe.createToken(this.card);
      if (error) {
        this.paymentError = error.message;
      } else {
        this.processPayment(token);
      }*/
    },
    processPayment(token) {
      this.form.stripe_token = token.id;
      this.form.post(`/api/email-verification-credits/purchase`)
        .then(response => {
          this.$toast.success('Purchase succeeded.')
          this.$emit('updated');
        })
        .catch(error => {
          console.log(error);
          this.$toast.error('Purchase failed')
        })
    }
  }
}
</script>
